import { c as _c } from "react/compiler-runtime";
import { Link } from "@opensea/next-ui-kit";
import { classNames, FlexCenter } from "@opensea/ui-kit";
import { useEffect, useRef } from "react";
import { ExpandedSearchResultItem } from "./ExpandedSearchResultItem";
import { useGetHrefForExpandedSearchResultItem } from "./utils";
const ROW_Y_PADDING_PX = 12;
export function ExpandedSearchResult(t0) {
  const $ = _c(38);
  const {
    item,
    selected,
    selectionMethod,
    selectedItemIndex,
    resultsListRef,
    onClick,
    onHover,
    onSelect
  } = t0;
  const divRef = useRef(null);
  const linkRef = useRef(null);
  let t1;
  if ($[0] !== resultsListRef || $[1] !== selected || $[2] !== selectedItemIndex || $[3] !== selectionMethod) {
    t1 = () => {
      if (!(selected && resultsListRef)) {
        return;
      }
      if (selectionMethod !== "keyboard") {
        return;
      }
      if (!(divRef.current && resultsListRef.current)) {
        return;
      }
      if (selectedItemIndex === 0) {
        resultsListRef.current.scrollTo(0, 0);
        return;
      }
      const divRect = divRef.current.getBoundingClientRect();
      const resultsRect = resultsListRef.current.getBoundingClientRect();
      const yPos = resultsListRef.current.scrollTop + (divRect.y - resultsRect.y);
      const topPos = resultsListRef.current.scrollTop;
      const bottomPos = resultsListRef.current.scrollTop + resultsRect.height;
      if (yPos < topPos) {
        divRef.current.scrollIntoView();
        return;
      }
      const divBottomPos = yPos + divRect.height + ROW_Y_PADDING_PX;
      if (divBottomPos > bottomPos) {
        resultsListRef.current.scrollTo({
          top: divBottomPos - resultsRect.height
        });
      }
    };
    $[0] = resultsListRef;
    $[1] = selected;
    $[2] = selectedItemIndex;
    $[3] = selectionMethod;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== item.id || $[6] !== resultsListRef || $[7] !== selected || $[8] !== selectedItemIndex || $[9] !== selectionMethod) {
    t2 = [item.id, resultsListRef, selectedItemIndex, selectionMethod, selected];
    $[5] = item.id;
    $[6] = resultsListRef;
    $[7] = selected;
    $[8] = selectedItemIndex;
    $[9] = selectionMethod;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  useEffect(t1, t2);
  let t3;
  if ($[11] !== onClick) {
    t3 = () => {
      onClick?.();
    };
    $[11] = onClick;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== onHover) {
    t4 = () => {
      onHover?.();
    };
    $[13] = onHover;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = {
      onClick: t3,
      onPointerEnter: t4
    };
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const interactivityProps = t5;
  const getHref = useGetHrefForExpandedSearchResultItem();
  let t6;
  if ($[18] !== getHref || $[19] !== item) {
    t6 = getHref(item);
    $[18] = getHref;
    $[19] = item;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const href = t6;
  const t7 = selected && "bg-bg-additional-2";
  let t8;
  if ($[21] !== t7) {
    t8 = classNames("w-full scroll-my-3 rounded-lg px-3 transition-colors duration-150 ease-out", t7);
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const t9 = selectedItemIndex !== undefined ? `search-result-${selectedItemIndex}` : undefined;
  let t10;
  if ($[23] !== item || $[24] !== onSelect || $[25] !== selected) {
    t10 = <ExpandedSearchResultItem item={item} onSelect={onSelect} selected={selected} />;
    $[23] = item;
    $[24] = onSelect;
    $[25] = selected;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== interactivityProps || $[28] !== item.id || $[29] !== selected || $[30] !== t10 || $[31] !== t8 || $[32] !== t9) {
    t11 = <FlexCenter aria-selected={selected} className={t8} id={t9} key={item.id} ref={divRef} role="option" {...interactivityProps}>{t10}</FlexCenter>;
    $[27] = interactivityProps;
    $[28] = item.id;
    $[29] = selected;
    $[30] = t10;
    $[31] = t8;
    $[32] = t9;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  const component = t11;
  if (href) {
    let t12;
    if ($[34] !== component || $[35] !== href || $[36] !== interactivityProps) {
      t12 = <Link className="*:pointer-events-none" href={href} ref={linkRef} variant="unstyled" {...interactivityProps}>{component}</Link>;
      $[34] = component;
      $[35] = href;
      $[36] = interactivityProps;
      $[37] = t12;
    } else {
      t12 = $[37];
    }
    return t12;
  }
  return component;
}